<!--start header-->
<header-element [userData]="userData" [workspaceList]="workspaceList" [selectedWorkspaceName]="selectedworskapceName"
    (emitchangeworkspace)="openDialog($event)" [notificationPanelVisible]="us.NotificationVisibilityEmitter"
    [closeAllPopup]="closeAllPanel" [selectedModule]="module"></header-element>
<!--end header-->

<!--start left-side-nav-->
<vcp-left-side-nav [userData]="userData" [selectedModule]="selectedModule" (sidebarToggle)="changeMiddleClass($event)">
</vcp-left-side-nav>
<!--end left-side-nav-->

<!--start layout-box-->
<div class="layout-box" id="main" (click)="leftBarClose()">
    <vah-new-loader *ngIf="loader" [type]="'page'"></vah-new-loader>
    <router-outlet></router-outlet>
</div>
<!--end layout-box-->

<vcp-low-resolution></vcp-low-resolution>